module.exports = __webpack_public_path__ + "img/upload-clear.e4e5ca32.svg";